import MagicVariations from './MagicVariations'

export default MagicVariations
